import React from "react";
import get from "lodash/get";
import { Toggle } from "react-powerplug";
import { Form, Input, Checkbox, Select, Radio, Button } from "antd";

import HTMLEditor from "./HTMLEditor";

const EventIntroEditor = ({
  event,
  form,
  getEventFieldName,
  onMediaSelectionRequested,
}) => (
  <React.Fragment>
    <Form.Item label="Type" labelCol={{ span: 3 }} wrapperCol={{ span: 21 }}>
      {form.getFieldDecorator(getEventFieldName(event, "intro.type"), {
        initialValue: get(event, "intro.type", "text"),
      })(
        <Radio.Group>
          <Radio.Button value="text">Text</Radio.Button>
          <Radio.Button value="html">HTML</Radio.Button>
          <Radio.Button value="image">Image</Radio.Button>
          <Radio.Button value="video">Video</Radio.Button>
        </Radio.Group>
      )}
    </Form.Item>
    {(() => {
      switch (get(event, "intro.type", "text")) {
        case "text":
          return (
            <Form.Item
              label="Text"
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              {form.getFieldDecorator(getEventFieldName(event, "intro.text"), {
                initialValue: get(event, "intro.text"),
              })(<Input />)}
            </Form.Item>
          );
        case "html":
          return (
            <Form.Item
              label="HTML"
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Toggle initial={false}>
                {({ on: editRaw, toggle }) => (
                  <>
                    {form.getFieldDecorator(
                      getEventFieldName(event, "intro.html"),
                      { initialValue: get(event, "intro.html") }
                    )(
                      !editRaw ? (
                        <HTMLEditor />
                      ) : (
                        <Input.TextArea autoSize={true} />
                      )
                    )}
                    <Checkbox onClick={toggle} checked={editRaw}>
                      Edit raw HTML
                    </Checkbox>
                  </>
                )}
              </Toggle>
            </Form.Item>
          );
        case "image":
          const handleImageSelectionResult = (result) => {
            if (result) {
              form.setFieldsValue({
                [getEventFieldName(event, "intro.image.src")]: result.publicUrl,
              });
            }
          };
          return (
            <Form.Item
              label="Image"
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              {form.getFieldDecorator(
                getEventFieldName(event, "intro.image.src"),
                {
                  rules: [
                    {
                      required: true,
                      message: "Provide an image url",
                    },
                    {
                      type: "url",
                      message: "Enter a valid image url",
                    },
                  ],
                  validateTrigger: ["onBlur"],
                  initialValue: get(event, "intro.image.src"),
                }
              )(<Input />)}
              <Button
                onClick={(e) =>
                  onMediaSelectionRequested(handleImageSelectionResult)
                }
              >
                Select media
              </Button>
            </Form.Item>
          );
        case "video":
          const handleVideoSelectionResult = (result) => {
            if (result) {
              form.setFieldsValue({
                [getEventFieldName(event, "intro.video.url")]: result.publicUrl,
              });
            }
          };
          return (
            <React.Fragment>
              <Form.Item
                label="Video url"
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                {form.getFieldDecorator(
                  getEventFieldName(event, "intro.video.url"),
                  {
                    rules: [
                      {
                        required: true,
                        message: "Provide a video url",
                      },
                      {
                        type: "url",
                        message: "Enter a valid video url",
                      },
                    ],
                    validateTrigger: ["onBlur"],
                    initialValue: get(event, "intro.video.url"),
                  }
                )(<Input />)}
                <Button
                  onClick={(e) =>
                    onMediaSelectionRequested(handleVideoSelectionResult)
                  }
                >
                  Select media
                </Button>
              </Form.Item>
              <Form.Item
                label="Video type"
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                {form.getFieldDecorator(
                  getEventFieldName(event, "intro.video.type"),
                  {
                    rules: [
                      {
                        required: true,
                        message: "Provide a video type",
                      },
                    ],
                    initialValue: get(event, "intro.video.type"),
                  }
                )(
                  <Select placeholder="Select a type">
                    <Select.Option value={null}>---</Select.Option>
                    {["video/mp4", "video/ogg"].map((type) => (
                      <Select.Option key={type} value={type}>
                        {type}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </React.Fragment>
          );
        default:
          return null;
      }
    })()}
  </React.Fragment>
);

export default EventIntroEditor;
